import { useState } from "react";
import { FileText, ArrowUpRight, Quote } from "lucide-react";
export const CitationAISection = () => {
  const [open, setOpen] = useState(true);
  return (
    <section id="citation-ai" className="recruit-citations recruit-section">
      <div className="recruit-shell recruit-feature-grid">
        <div className="recruit-source-dossier">
          <div className="recruit-board-label">
            <Quote size={18} />
            <span>Source-linked review</span>
            <span className="recruit-example-label">Illustrative</span>
          </div>
          <p className="recruit-chat-question">Has Avery taken a product through to launch?</p>
          <p>
            Avery’s resume describes taking a B2B onboarding platform from discovery to launch.
            Explore the scope of their contribution and the outcome in your next conversation.
          </p>
          <button
            className="recruit-citation-link"
            aria-expanded={open}
            aria-controls="citation-resume-excerpt"
            onClick={() => setOpen(!open)}
          >
            <FileText size={14} /> {open ? "Hide resume excerpt" : "Read resume excerpt"}{" "}
            <ArrowUpRight size={14} />
          </button>
          {open && (
            <blockquote id="citation-resume-excerpt" className="recruit-open-source">
              “Led a product squad of eight, taking a B2B onboarding platform from discovery to
              launch.”<cite>Avery Morgan · Resume · Fictional excerpt</cite>
            </blockquote>
          )}
        </div>
        <div>
          <p className="recruit-eyebrow">04 / Keep your judgment in the loop</p>
          <h2>
            A useful answer.
            <br />
            <span>A source you can inspect.</span>
          </h2>
          <p className="recruit-feature-body">
            Ask questions about candidates for a job. Citation AI can draw on available resumes,
            published Spotlight transcripts, and recruiter-requested interview transcripts, with
            links back to source material.
          </p>
          <p className="recruit-feature-note">
            AI can miss context or make mistakes. Read the cited passages and check important claims
            with the candidate.
          </p>
        </div>
      </div>
    </section>
  );
};
